import { useEffect } from "react";

import { ProductKeys } from "@atlassiansox/asc-stargate";

import { CrossFlowTouchpointProvider } from "@/components/cross-flow/touchpoint";
import {
    ConfluenceTemplatesUnifiedRelayPageTemplate,
    ConfluenceTemplatesUnifiedRelayPageTemplateProps
} from "@/templates/software/confluence/templates/confluence-templates-page/src/relay/confluence-templates-unified-relay-page.template";
import { experiments, useExperimentExposure } from "@/utils/experiment";
import { checkFeatureFlagGate, featureFlags } from "@/utils/feature-flags";

export const ConfluenceTemplatesRelayPage = ({
    queryRef
}: ConfluenceTemplatesUnifiedRelayPageTemplateProps) => {
    useEffect(() => {
        checkFeatureFlagGate(featureFlags.cpapiwdConfluenceTemplateLandingGate);
    }, []);

    return (
        <CrossFlowTouchpointProvider productKeys={[ProductKeys.CONFLUENCE]}>
            <ConfluenceTemplatesUnifiedRelayPageTemplate queryRef={queryRef} />
        </CrossFlowTouchpointProvider>
    );
};
